import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { Heading } from '@chakra-ui/react';
import { generateTextGradientFill } from '../../theme/gradients';
import { HomepageCardBackgroundGradient } from '../CUIHomepageCard/utils/backgroundGradients';
export const CUIHeading = Heading;
/**
 * This is our wrapper of Chakra's Heading, with Connect.com gradients. See full docs on [Chakra-ui](https://chakra-ui.com/docs/components/heading/usage)
 */

export const CUIGradientHeading = (_ref) => {
  let {
    gradientColor = HomepageCardBackgroundGradient.kyotoCarnaby,
    children
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["gradientColor", "children"]);

  return /*#__PURE__*/_jsx(CUIHeading, Object.assign({}, generateTextGradientFill(gradientColor), {}, rest, {
    children: children
  }));
};